var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutBasic',{attrs:{"showLinksMenu":false},scopedSlots:_vm._u([{key:"navigation-title",fn:function(){return [_vm._v("Integraciones")]},proxy:true},{key:"vista-previa",fn:function(){return [_c('router-view')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }